import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { removeTgHeatMapData } from "../../../actions/geo-data/GeoDataActions";
import {
  getTgInfo,
  removeSelectedTgId,
  toggleCampaignCustomTgApplied,
} from "../../../actions/org/OrgTargetGroupActions";

// Components
import Spinner from "../../../components/spinner/Spinner";
import {
  SelectedAttributesSection,
  SelectedPoiTypesSection,
} from "../../../components/campaign-tg-form/CampaignTgViewForm";

function RemoveTGButton() {
  const dispatch = useDispatch();

  function removeTgHeatMapFn() {
    dispatch(removeTgHeatMapData());
    dispatch(removeSelectedTgId());
    dispatch(toggleCampaignCustomTgApplied(false));
  }

  return (
    <button
      className="btn add-button btn-outline-primary shadow-none"
      onClick={removeTgHeatMapFn}
    >
      <span className="font-weight-bold">Remove</span>
    </button>
  );
}

/**
 * Selected TG Section
 */
export default function SelectedTargetGroupSection({
  selectedTgId,
  isCampaignCustomTgApplied = false,
}) {
  const dispatch = useDispatch();

  // Selector
  const tgInfoLoading = useSelector(
    (state) => state.orgTargetGroup.tgInfoLoading
  );

  const tgName = useSelector((state) => state.orgTargetGroup.tgName);

  const resultingPoiLayerList =
    useSelector((state) => state.orgTargetGroup.tgInfo.poiTypesMap) || {};

  // campaign summary
  const { campaign = {} } = useSelector(
    (state) => state.campaignReport.campaignSummary
  );
  const { poiTypeIds = [], tgAttributesIds = [] } = campaign;

  // tg attributes list
  const isGetTgAttrLoading = useSelector(
    (state) => state.orgTargetGroup.isGetTgAttrLoading
  );
  const { targetGroupAttrs = {}, poiTypesMap = {} } = useSelector(
    (state) => state.orgTargetGroup.originalData
  );

  // to get target group info
  useEffect(() => {
    if (selectedTgId) {
      dispatch(getTgInfo(selectedTgId));
    }
  }, [dispatch, selectedTgId]);

  // Checks for loading
  if (tgInfoLoading || isGetTgAttrLoading) {
    return (
      <div className="text-center mt-2">
        <Spinner />
      </div>
    );
  }

  // If Campaign Custom Tg applied for heatmap
  if (isCampaignCustomTgApplied) {
    return (
      <>
        {/* Selected Tg  */}
        <div className="navbar border-bottom py-3">
          <h4 className="mt-1">{"Campaign Target Group"}</h4>
          <RemoveTGButton />
        </div>

        <div className="m-3">
          {/* Selected Tg Attributes */}
          <SelectedAttributesSection
            tgAttributesIds={tgAttributesIds}
            targetGroupAttrs={targetGroupAttrs}
          />

          {/* Selected Poi Types */}
          <SelectedPoiTypesSection
            poiTypeIds={poiTypeIds}
            poiTypesMap={poiTypesMap}
          />
        </div>
      </>
    );
  }

  return (
    <>
      {/* Selected Tg  */}
      <div className="navbar border-bottom py-3">
        <h4 className="mt-1">{tgName}</h4>
        <RemoveTGButton />
      </div>

      {/* Resulting Poi Layers */}
      <h5 className="mt-3">Resulting POI Layers </h5>
      <ul className="row mb-0">
        {Object.values(resultingPoiLayerList).map((eachPoi) => (
          <li key={eachPoi.id} className="col-4 p-1">
            <span>{eachPoi.name}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
